import ViewTrigger from "./ViewTrigger";

export default ViewTrigger